<template>
	<div class='taskmaster-wrapper' v-if="taskmaster.length > 0">
		<div class="overlay" :class="{collapsed: !show_overlay || !active }">
			<div class="overlay-top border-bottom clearfix">
				<span v-if="active" class="expand-arrow left" :class="{collapsed: !show_overlay}" @click.prevent="show_overlay = !show_overlay"><i></i></span>

				<transition name="fade">
					<div key='overlay-active' class='overlay-controls p-1 pl-5' v-if="show_overlay && active">
						<a class='float-left text-white p-1' href="#" @click.prevent='reset()'>Reset</a>
						<span class='float-right text-secondary pr-3' v-if="!complete">{{current_task + 1}} of {{taskmaster.length}}</span>
					</div>

				</transition>
			</div>
			<transition name="fade">
				<div class='overlay-body text-left' v-if="show_overlay && active">
					<transition name="fade">
						<div v-if="!complete" key='not-complete'>

							<transition name="fade">
								<div key='status-error' v-if="result == 'error'" class='text-center'>
									<img src='~assets/icons/error.png' class='img-fluid'/>
								</div>
								<div key='status-success' v-else-if="result == 'success'" class='text-center'>
									<img src='~assets/icons/success.png' class='img-fluid'/>
								</div>
								<div key='status-waiting' v-else>
									{{description}}
									<input  v-if="task.type == 'input'" type='text' name='input' v-model='input' class='form-control mt-1' />
								</div>
							</transition>
						</div>
						<div v-else key='complete'>
							All tasks completed!
						</div>
					</transition>
				</div>
			</transition>
		</div>
		<span class="logo"><i></i></span>
		<div class="row actions" v-if="!active">
			<div class="col-12" >
				<a href="#" @click.prevent="active = true" class="text-white">
					Activate
				</a>
			</div>
		</div>
		<div class="row no-gutters actions" v-else>
			<div class="col-8 border-right">
				<a href="#" class="text-white" v-if="task.type == 'input'" @click.prevent='checkInput'>Submit</a>
			</div>
			<div class="col-4">
				<a href="#" class="text-white" @click.prevent="active = false">Quit</a>
			</div>
		</div>
	</div>
</template>
<style scooped lang="scss" rel="stylesheet/scss">
.taskmaster-wrapper {
	height: 100%;
}
.overlay {
	position: absolute;
	background: #231f20;
	color: #fff;
	height: 181px;
	top: -180px;
	left: -1px;
	width: calc(100% + 2px);
	transition-duration: 0.4s;
	transition-timing-function: ease;
	transition-property: top;
	border: 1px solid #fff;
	&.collapsed {
		top: 0;
		border-bottom: none;
		border-top: none;
	}
	.expand-arrow{
		z-index: 99;
	}
	.overlay-top {
		height: 34px;
	}
	.overlay-body {
		height: calc(100% - 34px);
		overflow: auto;
		position: relative;
		> div, > div > div {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			padding: 15px;
		}
	}
}
.actions {
	height: 34px;
	> div {
		height: 100%;
		line-height: 34px;
	}
}

</style>
<script>
import eventHub from '../../plugins/eventHub';
import {mapState} from "vuex";

export default {
	name: 'TaskMaster',
	data() {
		return {
			events: {},
			watchers: {},
			task: null,
			result: null,
			action_to: null,
			random_day: null,
			random_time: null,
			input: '',
			tasks: [],
			description: null,
			rec: null
		}
	},
	mounted() {
		this.setTasks();
	},
	computed: {
		...mapState([
				"assets_loaded",
				"muster",
				"day",
				"report",
				'log'
		]),
		show_overlay: {
			get() { return this.$store.state.taskmaster.show_overlay },
			set(value) { this.$store.commit('setState', ['taskmaster.show_overlay', value]) }
		},
		active: {
			get() { return this.$store.state.taskmaster.active },
			set(value) { this.$store.commit('setState', ['taskmaster.active', value]) }
		},
		current_task: {
			get() { return this.$store.state.taskmaster.current_task },
			set(value) { this.$store.commit('setState', ['taskmaster.current_task', value]) }
		},
		complete() {
			return this.current_task >= this.taskmaster.length;
		},
		taskmaster() {
			if (!this.assets_loaded) return [];
			let listing = [];
			for (let i in this.tasks) {
				let task = this.tasks[i];
				var hasData = true;
				if (task.rec) {
					for (let j in task.rec) {
						var data = task.rec[j].split('.');
						var entries = this.$store.state[data[0]];
						if (data[1]) entries = entries[data[1]];
						let arg = {};
						let key = data[0];
						if (data[1]) key = data[1];
						if (task.arg && task.arg[key]) arg = $.extend(true, {}, task.arg[key]);
						for (let j in arg) {
							let param = arg[j].split('.');
							if (param[0] == 'rec') {
								delete arg[j];
							}
						}


						let rec = this.$finder.all(arg, entries);
						if (Object.keys(rec).length == 0) {
							hasData = false;
							break;
						}
					}
				}

				if (hasData) listing.push(task);
			}
			while (listing.length < 10) {
				listing.push(this.$finder.random(listing))
			}
			return listing;
			// return this.$finder.random(listing);
		}
	},
	watch: {
		active() {
			if (!this.complete) this.setEvents();
		},
		current_task() {
			if (!this.complete) this.setEvents();
		}

	},
	methods: {
		setTasks() {
			let tasks = [];
			this.$config.data.taskmaster.forEach((row) => {
				if (row.auth && !this.$auth.hasAccess(row.auth)) return;
				tasks.push(row);
			})
			this.tasks = tasks.sort(() => Math.random() - 0.5);
		},
		setEvents() {
			this.task = this.taskmaster[this.current_task];

			this.rec = {};

			this.random_day = Math.max(1, Math.floor(Math.random() * this.day));
			if (this.random_day == this.day ) this.random_time = Math.floor(Math.random() * this.time)
			else {
				let eod = this.$finder.first({type: 'eod', day: this.random_day}, this.log);
				this.random_time = Math.floor(Math.random() * eod.time);
			}

			if (this.task.rec) {
				for (let i in this.task.rec) {
					let data = this.task.rec[i].split('.');
					let key = data[0];
					if (data[1]) key = data[1];

					var entries = this.$store.state[data[0]];

					if (data[1]) entries = entries[data[1]];
					if (data[0] == 'watcher') {
						entries = entries[this.random_day][this.rec['workers'].id];
					}


					let arg = {};

					if (this.task.arg && this.task.arg[key]) arg = $.extend(true, {}, this.task.arg[key]);
					for (let j in arg) {
						let param = arg[j].split('.');
						if (param[0] == 'rec') {
							param = this.$finder.resolve(arg[j], this);
						}
						arg[j] = param;
					}

					this.rec[key] = this.$finder.random(this.$finder.all(arg, entries));
				}
			}



			if (this.rec) {
				this.description = this.task.description;

				for (var i in this.rec) {
					for (let j in this.rec[i]) {
						let regex = new RegExp("{{rec." + i + "." + j + "}}", "g");
						this.description = this.description.replace(regex, this.rec[i][j]);

						let functions = this.description.match(/\{\{\$worker\.(.*?)\}\}/g) || [];
						functions.forEach((f, index) => {
							let method = f.replace(/\{|\}/g, "").split(".")[1];
							this.description = this.description.replace(f, this.$worker[method](this.rec['workers'].id));
						})
					}
				}
			}

			this.description = this.description.replace(/\{\{random_day\}\}/g, this.random_day);
			this.description = this.description.replace(/\{\{random_time\}\}/g, this.$datetime.time(this.random_time, this.random_day));
			this.description = this.description.replace(/\{\{random_datetime\}\}/g, this.$datetime.datetime(this.random_time, this.random_day));


			for (var i in this.events) {
				eventHub.$off(i);
				delete this.events[i];
			}
			for (var i in this.watchers) {
				delete this.watchers[i];
			}
			if (!this.task) return;

			if (this.task.event && this.active) {
				eventHub.$on(this.task.event, this.completeTask);
				this.events[this.task.event] = 'on';
			}

			if (this.active && this.task.watch && !this.watchers[this.task.watch]) {
				this.watchers[this.task.watch] = 'on';
				this.$watch(this.task.watch, function(value) {
					if (value >= this.task.value && this.watchers[this.task.watch] != undefined) this.completeTask(true, true)
				});

			}
		},
		completeTask(value, force) {
			if (this.action_to) clearTimeout(this.action_to);
			if (force) return this.success();
			let entry = this.$finder.resolve(this.task.entry, this);
			if (value == entry) {
				this.success();
			}
			else {
				this.failure();
			}
		},
		checkInput() {

			let input = this.input;
			let entry;
			if (this.task.data) {
				entry = this.$finder.resolve(this.task.data, this.$store.state);
				if (this.task.entry) {
					entry = [entry[this[ this.task.entry ] - 1]] || [0];
				}
			}
			else {
				entry = [];
				if (this.task.entry.constructor !== Array) {
					this.task.entry = [this.task.entry];
				}
				this.task.entry.forEach((param) => {
					param = param.split('+');
					let value = [];
					for (var i in param) {
						value.push(this.$finder.resolve(param[i], this));
					}
					value = value.join(' ');

					entry.push(value);
				})
			}

			if (this.task.data_type == 'string') {
				input = input.toLowerCase();
				entry = entry.map(v => v.toLowerCase());
			}
			else if (this.task.data_type == 'number') {
				entry = entry.map(v => this.$number.format(v));
			}

			console.log('Your input is: '+ input+'; Correct answer is: ', entry);
			if (entry.includes(input)) {
				this.success();
			}
			else {
				this.failure();
			}
			this.input = '';

		},
		success() {
			this.result = 'success';
			this.action_to = setTimeout(()=>{
				if (this.current_task < this.taskmaster.length) this.current_task++;
				this.result = null;
			},3000);
		},
		failure() {
			this.result = 'error';
				this.action_to = setTimeout(()=>{
					this.result = null;
				},3000);
		},
		reset() {
			this.random_day = Math.max(1, Math.floor(Math.random() * this.day));
			this.current_task = 0;
			this.result = null;
			this.input = '';
			this.setTasks();
			this.setEvents();

		}
	}

}
</script>
